import { applyThemeMetadata, initializePublicConfig } from './publicConfig'

const publicConfig = initializePublicConfig()

applyThemeMetadata(publicConfig)
